import { JwVideoTeaser } from '@/components/JwVideo/Teaser';
import { Layout } from '@/components/Layout';
import { ListGrid } from '@/components/ListGrid';
import { PageMeta } from '@/components/PageMeta';
import { SchemaMarkup } from '@/components/SchemaMarkup';
import { VideoBaseContent } from '@/components/VideoBaseContent';
import { componentTheme } from '@/styles/JwVideoTeaser';
import { Content } from '@/types/content';
import { getCurrentBrand } from '@/utils/getCurrentBrand';
import { getDomain } from '@/utils/getDomain';
import { HOUR } from '@/utils/ttl';
import { withCacheControlHeaders } from '@/utils/withCacheControlHeaders';
import { VIDEO_PAGES_CONFIG } from 'base/configs/video';
import { VideoAllShowsPageData, getAllShowsPageData } from 'lib/data/video';
import { omitBy } from 'lodash-es';
import { GetServerSideProps, NextPage } from 'next';
import { isUndefined } from 'typesafe-utils';

const brand = getCurrentBrand();

const pageData: Content = {
  meta: {},
  type: 'videoWebPage',
  children: [],
  data: omitBy(
    {
      brand: brand.name,
      titleSuffix: ' | Video',
      seoTitle: VIDEO_PAGES_CONFIG.allShowPage?.seoTitle,
      domain: brand.host,
      canonical: `${getDomain()}video/show`,
      seoDescription: VIDEO_PAGES_CONFIG.allShowPage?.seoDescription,
      ogImageUrl: `${getDomain()}/image/${brand.slug}-logo.svg`,
    },
    isUndefined,
  ),
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const data = (await getAllShowsPageData()) ?? {};

  withCacheControlHeaders(context.res, 1 * HOUR);

  return { props: data };
};

const ShowsPage: NextPage<VideoAllShowsPageData> = (props) => {
  const { shows, tagsList } = props;

  return (
    <Layout
      content={
        <>
          <PageMeta pageData={pageData} />
          <SchemaMarkup pageData={pageData} />

          <VideoBaseContent
            label="Populärt:"
            tagsList={tagsList}
            breadcrumbs={[{ label: 'Video start', url: '/video' }, { label: 'Shows' }]}
            headline={VIDEO_PAGES_CONFIG.allShowPage?.headline}
            description={VIDEO_PAGES_CONFIG.allShowPage?.description}
            options={{ $coverBox: { className: 'rounded-none' } }}
          >
            <ListGrid
              content={shows.playlist?.map((media) => (
                <JwVideoTeaser
                  key={media.mediaId}
                  mediaId={media.mediaId}
                  thumbnail={media.image}
                  isStillImage
                  title={media.title}
                  teaserLink={media.url}
                  options={
                    {
                      theme: componentTheme('video_pages'),
                      $link: {
                        target: '_self',
                      },
                      variant: 'vertical',
                      $playIcon: { className: '!block' },
                      $media: {
                        $image: {
                          src: media.image,
                          size: 'vertical',
                        },
                      },
                      $content: {
                        colors: 'default',
                        $tag: {
                          // @ts-expect-error: `ShowsPage` is a non-slot architecture
                          theme: componentTheme('tag'),
                        },
                      },
                    } as const
                  }
                />
              ))}
            />
          </VideoBaseContent>
        </>
      }
    />
  );
};

export default ShowsPage;
